import React from 'react';

import {ButtonBase, Stack} from '@mui/material';

import {Text} from 'components/index';
import {useTranslation} from 'hooks';

const styles = {
    saveButtonContainer: {
        marginTop: '20px',
        marginBottom: '20px',
    },
    saveButton: {
        color: 'white.main',
        fontSize: '18px',
        fontWeight: '500',
        cursor: 'pointer',
        display: 'flex',
        textTransform: 'uppercase',
        justifyContent: 'center',
        padding: 2,
        backgroundColor: 'grey.dark',
        '&:hover': {
            backgroundColor: 'grey.light',
        },
    }
};

const SaveButton = ({action, type = '', ml, mr, mt, mb, buttonText = 'ui.actions.cancel'}) => {
    const translate = useTranslation();
    return (
        <Stack sx={[
            styles.saveButtonContainer,
            ml !== undefined && {marginLeft: ml},
            mr !== undefined && {marginRight: mr},
            mt !== undefined && {marginTop: mt},
            mb !== undefined && {marginBottom: mb},
        ]}>
            <ButtonBase
                sx={styles.saveButton}
                variant="contained"
                {...(action ? {onClick: action} : {})}
                {...(type ? {type: type} : {})}
            >
                <Text>{translate(buttonText)}</Text>
            </ButtonBase>
        </Stack>
    );
};

export default SaveButton;
